// extracted by mini-css-extract-plugin
module.exports = {"logoImg":"JhZKK7Kh","condensed":"vjBaPbS3","disabled":"J2zpHFUc","logoFallback":"slLO12GK"};